import {createSelector} from "reselect";
import * as reduxSelectors from "../store/application.reducers";
import {userHasAccessRights, canViewConfiguration} from "utils/accessRights.function";


export const currentPreferenceSelector  = createSelector([reduxSelectors.getUsersSettings], userSetting => {
    return {
        taskDueDays: userSetting.taskDueDays,
        showCommentOnApprove: userSetting.showCommentOnApprove,
        nextTask: userSetting.nextTask,
        pdfViewer: window.localStorage.getItem("@@pdf/defaultPDF") ? window.localStorage.getItem("@@pdf/defaultPDF") === "true" : true,
        substitute:userSetting.substitute,
        active:userSetting.active,
        activeFrom:userSetting.from,
        activeTo:userSetting.to
    }
});

export const userRightsValidationSelector = createSelector([reduxSelectors.getUsersData], userData => {
    return (!userHasAccessRights(userData.userRoles) && canViewConfiguration(userData.userRoles));
});